<template>
  <div>
    <h4>{{ roundType }}</h4>
    <b-form-group>
      <template slot="label">
        <b-icon-patch-question-fill
            variant="primary"
            @click="toggleVisibility('form-numberOfRounds')">
        </b-icon-patch-question-fill>
        {{ $t('waiting_room.create_modal.stage_config.number_of_rounds') }}
      </template>
      <b-alert
          :show="visibleInstructions.includes('form-numberOfRounds')"
          variant="secondary">
        {{ $t('waiting_room.long_instructions.number_of_rounds') }}
      </b-alert>
      <b-form-input id="form-numberOfRounds"
                    v-model="data.numberOfRounds"
                    :state="validateState('numberOfRounds')"
                    tooltip :title="$t('waiting_room.short_instructions.number_of_rounds')">
      </b-form-input>
      <b-form-invalid-feedback>{{ $t('waiting_room.errors.number_of_rounds') }}</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group>
      <template slot="label">
        <b-icon-patch-question-fill
            variant="primary"
            @click="toggleVisibility('form-cmsPageKeyName')">
        </b-icon-patch-question-fill>
        {{ $t('waiting_room.create_modal.stage_config.cms_page_key_name') }}
      </template>
      <b-alert
          :show="visibleInstructions.includes('form-cmsPageKeyName')"
          variant="secondary">
        {{ $t('waiting_room.long_instructions.cms_page_key_name') }}
      </b-alert>
      <b-form-select id="form-cmsPageKeyName"
                     v-model="data.cmsPageKeyName"
                     :options="cmsPagesList"
                     text-field="title"
                     value-field="keyName"
                     :state="validateState('cmsPageKeyName')"
                     tooltip :title="$t('waiting_room.short_instructions.cms_page_key_name')">
        <b-form-select-option value="null" disabled>{{ $t('select.placeholder') }}</b-form-select-option>
      </b-form-select>
      <b-form-invalid-feedback>{{ $t('waiting_room.errors.cms_page_key_name') }}</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group>
      <template slot="label">
        <b-icon-patch-question-fill
            variant="primary"
            @click="toggleVisibility('form-timeForAnswer')">
        </b-icon-patch-question-fill>
        {{ $t('waiting_room.create_modal.stage_config.time_for_answer') }}
      </template>
      <b-alert
          :show="visibleInstructions.includes('form-timeForAnswer')"
          variant="secondary">
        {{ $t('waiting_room.long_instructions.round_configuration.time_for_answer') }}
      </b-alert>
      <b-form-input id="form-timeForAnswer"
                    v-model="data.roundConfiguration.timeForAnswer"
                    :state="validateState(['roundConfiguration','timeForAnswer'])"
                    tooltip :title="$t('waiting_room.short_instructions.round_configuration.time_for_answer')">
      </b-form-input>
      <b-form-invalid-feedback>{{ $t('waiting_room.errors.round_configuration.time_for_answer') }}</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group v-if="roundType==='COLLECTING'">
      <template slot="label">
        <b-icon-patch-question-fill
            variant="primary"
            @click="toggleVisibility('form-numberOfPoints')">
        </b-icon-patch-question-fill>
        {{ $t('waiting_room.create_modal.stage_config.number_of_points') }}
      </template>
      <b-alert
          :show="visibleInstructions.includes('form-numberOfPoints')"
          variant="secondary">
        {{ $t('waiting_room.long_instructions.round_configuration.number_of_points') }}
      </b-alert>
      <b-form-input id="form-numberOfPoints"
                    v-model="data.roundConfiguration.numberOfPoints"
                    :state="validateState(['roundConfiguration','numberOfPoints'])"
                    tooltip :title="$t('waiting_room.short_instructions.round_configuration.number_of_points')">
      </b-form-input>
      <b-form-invalid-feedback>{{ $t('waiting_room.errors.round_configuration.number_of_points') }}</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group v-if="roundType==='BETTING'">
      <template slot="label">
        <b-icon-patch-question-fill
            variant="primary"
            @click="toggleVisibility('form-availableStakes')">
        </b-icon-patch-question-fill>
        {{ $t('waiting_room.create_modal.stage_config.available_stakes') }}
      </template>
      <b-alert
          :show="visibleInstructions.includes('form-availableStakes')"
          variant="secondary">
        {{ $t('waiting_room.long_instructions.round_configuration.available_stakes') }}
      </b-alert>
      <b-form-input id="form-availableStakes"
                    v-model="data.roundConfiguration.availableStakes"
                    :state="validateState(['roundConfiguration','availableStakes'])"
                    tooltip :title="$t('waiting_room.short_instructions.round_configuration.available_stakes')">
      </b-form-input>
      <b-form-invalid-feedback>{{ $t('waiting_room.errors.round_configuration.available_stakes') }}</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group v-if="roundType==='CONQUERING'">
      <template slot="label">
        <b-icon-patch-question-fill
            variant="primary"
            @click="toggleVisibility('form-pointsToSteal')">
        </b-icon-patch-question-fill>
        {{ $t('waiting_room.create_modal.stage_config.points_to_steal') }}
      </template>
      <b-alert
          :show="visibleInstructions.includes('form-pointsToSteal')"
          variant="secondary">
        {{ $t('waiting_room.long_instructions.round_configuration.points_to_steal') }}
      </b-alert>
      <b-form-input id="form-pointsToSteal"
                    v-model="data.roundConfiguration.pointsToSteal"
                    :state="validateState(['roundConfiguration','pointsToSteal'])"
                    tooltip :title="$t('waiting_room.short_instructions.round_configuration.points_to_steal')">
      </b-form-input>
      <b-form-invalid-feedback>{{ $t('waiting_room.errors.round_configuration.points_to_steal') }}</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group v-if="roundType==='SPRINTING'">
      <template slot="label">
        <b-icon-patch-question-fill
            variant="primary"
            @click="toggleVisibility('form-pointsMultiplier')">
        </b-icon-patch-question-fill>
        {{ $t('waiting_room.create_modal.stage_config.points_multiplier') }}
      </template>
      <b-alert
          :show="visibleInstructions.includes('form-pointsMultiplier')"
          variant="secondary">
        {{ $t('waiting_room.long_instructions.round_configuration.points_multiplier') }}
      </b-alert>
      <b-form-input id="form-pointsMultiplier"
                    v-model="data.roundConfiguration.pointsMultiplier"
                    :state="validateState(['roundConfiguration','pointsMultiplier'])"
                    tooltip :title="$t('waiting_room.short_instructions.round_configuration.points_multiplier')">
      </b-form-input>
      <b-form-invalid-feedback>{{ $t('waiting_room.errors.round_configuration.points_multiplier') }}</b-form-invalid-feedback>
    </b-form-group>
  </div>
</template>

<script>
import {required, integer, minValue, helpers} from "vuelidate/lib/validators";

//had to define own regex for fractions - built in types (decimal, numeric) didn't satisfy business requirements
const fraction = helpers.regex('fraction', /^[-]?\d+([.,]\d+)?$/);
//had to define own regex for not negative fractions - built in minValue type crapped out in conjunction with fractions
const notNeg = helpers.regex('notNeg', /^[^-]/);
//had to define own regex for stakes - no built in type for array or array string
const stakesFormat = helpers.regex('stakesFormat', /^\d+,\d+,\d+,\d+$/)

export default {
  components: {},
  props: ['roundType', 'cmsPagesList', 'clonedData'],
  validations() {
    if (this.roundType === 'COLLECTING') {
      return {
        data: {
          numberOfRounds: {required, integer, minValue: minValue(1)},
          cmsPageKeyName: {},
          roundConfiguration: {
            timeForAnswer: {required, integer, minValue: minValue(1)},
            numberOfPoints: {required, integer, minValue: minValue(1)},
          }
        }
      }
    }
    if (this.roundType === 'BETTING') {
      return {
        data: {
          numberOfRounds: {required, integer, minValue: minValue(1)},
          cmsPageKeyName: {},
          roundConfiguration: {
            timeForAnswer: {required, integer, minValue: minValue(1)},
            availableStakes: {required, stakesFormat},
          }
        }
      }
    }
    if (this.roundType === 'CONQUERING') {
      return {
        data: {
          numberOfRounds: {required, integer, minValue: minValue(1)},
          cmsPageKeyName: {},
          roundConfiguration: {
            timeForAnswer: {required, integer, minValue: minValue(1)},
            pointsToSteal: {required, integer, minValue: minValue(1)},
          }
        }
      }
    }
    if (this.roundType === 'SPRINTING') {
      return {
        data: {
          numberOfRounds: {required, integer, minValue: minValue(1)},
          cmsPageKeyName: {},
          roundConfiguration: {
            timeForAnswer: {required, integer, minValue: minValue(1)},
            pointsMultiplier: {required, fraction, notNeg},
          }
        }
      }
    }
  },
  data() {
    return {
      data: {
        numberOfRounds: this.clonedData.numberOfRounds ?? null,
        cmsPageKeyName: this.clonedData.cmsPageKeyName ?? null,
        roundConfiguration: {
          timeForAnswer: this.clonedData.roundConfiguration.timeForAnswer ?? null,
          numberOfPoints: this.clonedData.roundConfiguration.numberOfPoints ?? null,
          availableStakes: this.clonedData.roundConfiguration.availableStakes ? this.clonedData.roundConfiguration.availableStakes.join(",") : null,
          pointsToSteal: this.clonedData.roundConfiguration.pointsToSteal ?? null,
          pointsMultiplier: this.clonedData.roundConfiguration.pointsMultiplier ?? null,
        }
      },
      visibleInstructions: [],
      errors: {
        numberOfRounds: 'Number of Rounds is a required field whose value has to be an integer above 1!',
        cmsPageKeyName: null,
        roundConfiguration: {
          timeForAnswer: 'timeForAnswer is a required field whose value has to be an integer above 1!',
          numberOfPoints: 'numberOfPoints is a required field whose value has to be an integer above 1!',
          availableStakes: 'availableStakes is a required field whose value has to be properly formatted ' +
              '(check the instructions under the question mark)!',
          pointsToSteal: 'pointsToSteal is a required field whose value has to be an integer above 1!',
          pointsMultiplier: 'pointsMultiplier is a required field whose value has to be numerical ' +
              '(use a decimal point, not a comma) and cannot be negative!'
        }
      },
      short_instructions: {
        numberOfRounds: 'The number of rounds/questions in this Stage. This field is required.',
        cmsPageKeyName: 'The CMS key for a page to be used as background. This field is optional.',
        roundConfiguration: {
          timeForAnswer: 'The time a player has to choose an answer. This field is required.',
          numberOfPoints: 'The points a player can win. This field is required.',
          availableStakes: 'The possible bets a player can make. This field is required.',
          pointsToSteal: 'The amount of points a player can steal. This field is required.',
          pointsMultiplier: 'The rate at which points are multiplied. This field is required.'
        }
      },
      long_instructions: {
        numberOfRounds: 'You can choose the number of rounds this Stage will have - each round has one question. ' +
            'This has to be an integer greater than 1. This field is required.',
        cmsPageKeyName: 'You can choose one of the CMS keys for a set of rules to be displayed before the first question. ' +
            'This field is optional (and if left blank no rules will be displayed). ' +
            'The rules can be added/edited in the CMS section of the main menu.',
        roundConfiguration: {
          timeForAnswer: 'You can set the amount of time the players have to choose an answer. ' +
              'This should be the number of seconds allocated. This has to be an integer greater than 1. This field is required.',
          numberOfPoints: 'You can set the amount of points the first player to answer correctly will be awarded. ' +
              'This has to be an integer greater than 1. This field is required.',
          availableStakes: 'You can set the possible amounts a player can bet on a question. ' +
              'Before each question players will bet points before knowing the question. ' +
              'Players can win back double the amount they bet if they answer correctly or they can lose their bet. ' +
              'This has to be a set of 4 (non-negative) integers. The values should be separated by commas (,). This field is required.',
          pointsToSteal: 'You can set the amount of points the first player to answer correctly will steal from the remaining players. ' +
              'This has to be an integer greater than 1. This field is required.',
          pointsMultiplier: 'You can set the rate at which points are multiplied. After each question the time remaining ' +
              '(in seconds) will be multiplied by this multiplier to calculate the points gained for answering correctly. ' +
              'The exact formula is: `PointsMultiplier` * `TimeLeftForAnswer` / `TimeForAnswer` (both times are stored in seconds) ' +
              'This has to be a number greater than 0. This field is required.'
        }
      }
    }
  },
  filters: {},
  methods: {
    isValid() {
      this.$v.$touch();
      return this.$v.$invalid === false;
    },
    validateState(entry) {
      if (entry.constructor.name === 'Array') {
        switch (entry.length) {
          case 3:
            entry = this.$v.data[entry[0]][entry[1]][entry[2]];
            break;
          case 2:
            entry = this.$v.data[entry[0]][entry[1]];
            break;
        }
      } else {
        entry = this.$v.data[entry];
      }
      const {$dirty, $error} = entry;
      return $dirty ? !$error : null;
    },
    toggleVisibility(id) {
      const index = this.visibleInstructions.indexOf(id);

      if (index > -1) {
        this.visibleInstructions.splice(index, 1);
      } else {
        this.visibleInstructions.push(id);
      }
    },
    getData() {
      if (this.roundType === 'COLLECTING') {
        return {
          roundType: this.roundType,
          cmsPagesList: this.cmsPagesList,
          numberOfRounds: this.data.numberOfRounds,
          cmsPageKeyName: this.data.cmsPageKeyName,
          roundConfiguration: {
            timeForAnswer: this.data.roundConfiguration.timeForAnswer,
            numberOfPoints: this.data.roundConfiguration.numberOfPoints,
          }
        }
      }
      if (this.roundType === 'BETTING') {
        return {
          roundType: this.roundType,
          cmsPagesList: this.cmsPagesList,
          numberOfRounds: this.data.numberOfRounds,
          cmsPageKeyName: this.data.cmsPageKeyName,
          roundConfiguration: {
            timeForAnswer: this.data.roundConfiguration.timeForAnswer,
            availableStakes: this.data.roundConfiguration.availableStakes.split(','),
          }
        }
      }
      if (this.roundType === 'CONQUERING') {
        return {
          roundType: this.roundType,
          cmsPagesList: this.cmsPagesList,
          numberOfRounds: this.data.numberOfRounds,
          cmsPageKeyName: this.data.cmsPageKeyName,
          roundConfiguration: {
            timeForAnswer: this.data.roundConfiguration.timeForAnswer,
            pointsToSteal: this.data.roundConfiguration.pointsToSteal,
          }
        }
      }
      if (this.roundType === 'SPRINTING') {
        return {
          roundType: this.roundType,
          cmsPagesList: this.cmsPagesList,
          numberOfRounds: this.data.numberOfRounds,
          cmsPageKeyName: this.data.cmsPageKeyName,
          roundConfiguration: {
            timeForAnswer: this.data.roundConfiguration.timeForAnswer,
            pointsMultiplier: this.data.roundConfiguration.pointsMultiplier,
          }
        }
      }
    }
  }
}
</script>
